import { useSiteMetadata } from "@reflexjs/gatsby-theme-core";
import * as React from 'react';
export default {
  useSiteMetadata,
  React
};